import * as Yup from "yup";

export const validationSchema = (t) =>
    Yup.object({
        country_id: Yup.object().required(t("required_text")),
        registration_number: Yup.string().min(1).max(15).required(t("required_text")),
        transport_bodytype_ids: Yup.array().min(1, t("required_text")).required(t("required_text")),
        transports_loading_types: Yup.array().typeError(" "),
        length: Yup.number().typeError(" "),
        width: Yup.number().typeError(" "),
        height: Yup.number().typeError(" "),
        volume: Yup.number().typeError(" "),
    });
